import React from 'react'
import dashCar from './res/dashCar.mp4'
import './UserHome.css'

function UserHome(){

    return (
        <div>
        <section className="showcase">
        <video src={dashCar} muted loop autoPlay></video>
        <div className="overlay"></div>
        <div className="text">
          <h2>H2O Motors</h2> 
          <h3>We make car shopping easy</h3>
          <p>Our dedication and care for each vehicle allows you a peace of mind. Browse our shop, contact us, and let's talk about vehicles. We're Houston's #1 used car dealer. Let us show you why.</p>
          <a href="vehicle-catalog">Browse</a>
        </div>
        <ul className="social">
          <li><a href="/"><img src="https://i.ibb.co/x7P24fL/facebook.png" alt='facebook' /></a></li>
          <li><a href="/"><img src="https://i.ibb.co/Wnxq2Nq/twitter.png" alt='twitter'/></a></li>
          <li><a href="/"><img src="https://i.ibb.co/ySwtH4B/instagram.png" alt='instagram'/></a></li>
        </ul>
      </section>
      </div>
    );
}
export default UserHome;